import { z } from "zod";

export const calendarStatePayloadSchema = z.object({
	user_id: z.uuid(),
	iat: z.number(),
});

export type CalendarStatePayload = z.infer<typeof calendarStatePayloadSchema>;
